import { render, staticRenderFns } from "./PhotoGroupCarouselComponent.vue?vue&type=template&id=c4717d14"
import script from "./PhotoGroupCarouselComponent.vue?vue&type=script&lang=js"
export * from "./PhotoGroupCarouselComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports